module.exports = __webpack_public_path__ + "website/img/successfulDetail_0_4.bc75a8ef.png";